import React, { Component } from 'react'
import { ALGORITHM_VERSION_NEW_ACTIVITY_FACTORS, getDaysSinceWeighIn } from '../../util'
import Icon from "../../../../../../images/settings-icons/setting-activity.png";
import { Accordion } from "./components/setting-accordion";
import { SaveButton } from "./components/save-button";
import styled from "styled-components";
import { modifyUser } from "../../../../../../api";
import {UserCheckinWarning} from './components/user-check-in-warning'
import CheckinFormPortal from './components/check-in-2-4'
import VacationModeModal from './vacation-mode-modal'

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
class UpdateActivityLevel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lifestyle_level: this.props.lifestyle_level,
      exercise_level: this.props.exercise_level,
      show5DayWeighInExplanation: false,
      showWeighInExplanation: false,
      showEstimatedWeightExplanation: false,
      expanded: false,
      error: '',
      isSubmitting: false,
      disableSubmit: true,
      show: false,
      showUserCheckinWarning: false,
      showCheckinFormPortal: false,
      showVacationModal: false,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(
      this.props.lifestyle_level !== nextProps.lifestyle_level ||
      this.props.exercise_level !== nextProps.exercise_level
    ) {
      this.setState({
        lifestyle_level: nextProps.lifestyle_level,
        exercise_level: nextProps.exercise_level
      })
    }
  }

  handlePanelChange = (event, expanded) => {
    this.setState({ expanded: expanded })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: Number(e.target.value),
      disableSubmit: false
    })
  }

  handleSubmit = (e) => {
    if(this.state.exercise_level === null || this.state.lifestyle_level === null) {
      this.setState({ error: 'Please select a level from both lists' })
      return
    }
    
    if(this.props.vacationMode !== 0) {
      this.setState({showVacationModal: true})
      return
    }

    const daysSinceWeighIn = getDaysSinceWeighIn(this.props.lastWeighInDate)

    if(daysSinceWeighIn !== 0) {
      if(daysSinceWeighIn >= 5) {
        this.setState({ showUserCheckinWarning: true })
      } else {
        this.setState({ showCheckinFormPortal: true })
      }
      return
    }

    if(this.props.weighins[0].near_period && !this.props.weighins[0].estimated_weight) {
      this.setState({ showEstimatedWeightExplanation: true })
      return
    }

    this.setState({ isSubmitting: true });
    modifyUser(this.props.userId, this.props.portalId, {
      activity_level: (Number(this.state.lifestyle_level) + Number(this.state.exercise_level)) / 2,
      exercise_level: this.state.exercise_level,
      lifestyle_level: this.state.lifestyle_level
    }).then(() => {
      this.setState({
        isSubmitting: false,
        error: '',
        expanded: false,
        show: false,
      })
      this.props.loadPortalAccount();
      this.props.openSnackbar('Activity level has been updated successfully', false)
    }).catch((err) => {
      this.setState({
        isSubmitting: false,
        expanded: false,
      })
      this.props.openSnackbar('Unable to update activity level', true)
    })
  }

  getActivityFactorTag = (activity_factor, algorithm_version) => {
    const limits = algorithm_version >= ALGORITHM_VERSION_NEW_ACTIVITY_FACTORS ? [1.2875, 1.4625, 1.6375, 1.8125] : [1.15, 1.3, 1.5, 1.7]
    if(activity_factor < limits[0])
      return 'SEDENTARY'
    else if(activity_factor < limits[1])
      return 'LIGHTLY ACTIVE'
    else if(activity_factor < limits[2])
      return 'MODERATELY ACTIVE'
    else if(activity_factor < limits[3])
      return 'VERY ACTIVE'
    else
      return 'INTENSE'
  }

  render() {
    const daysAfterLastCheckIn = getDaysSinceWeighIn(this.props.lastWeighInDate);

    return (
      <>
      <Accordion
        show={this.state.show}
        setShow={(val) => this.setState({show: val})}        
        icon={Icon}
        settingName="Activity level"
        currentSetting={this.getActivityFactorTag(this.props.activity_factor, this.props.algorithm_version)}
        description="Select this user's exercise and lifestyle activity level"
        // alternateColor
      >
        <>
          <p style={{color: 'red'}}>{this.state.error}</p>
          <div className='preferences-activity-hours-category-container' >
            <div className='preferences-activity-hours-category' id='preferences-activity-hours-category-lifestyle'>
              <h2>LIFESTYLE</h2>
               <div className='preferences-activity-hours-category-button-group'>
                 <button className='avn-button-radio-text-container' name='lifestyle_level' value={0} onClick={this.handleChange} style={{backgroundColor: (this.state.lifestyle_level === 0) ? '#e5e9f3' : null}}>
                   <div className={(this.state.lifestyle_level === 0) ? 'avn-circle-radio-outer-ring-active' : 'avn-circle-radio-outer-ring'}>
                     <div className={(this.state.lifestyle_level === 0) ? 'avn-circle-radio-inner-circle-active' : 'avn-circle-radio-inner-circle'}></div>
                   </div>
                   <p><strong>Sedentary </strong>Most of my day involves sitting.</p>
                 </button>
                 <button className='avn-button-radio-text-container' name='lifestyle_level' value={1} onClick={this.handleChange} style={{backgroundColor: (this.state.lifestyle_level === 1) ? '#e5e9f3' : null}}>
                   <div className={(this.state.lifestyle_level === 1) ? 'avn-circle-radio-outer-ring-active' : 'avn-circle-radio-outer-ring'}>
                     <div className={(this.state.lifestyle_level === 1) ? 'avn-circle-radio-inner-circle-active' : 'avn-circle-radio-inner-circle'}></div>
                   </div>
                   <p><strong>Lightly Active </strong>I do some light walking and standing.</p>
                 </button>
                 <button className='avn-button-radio-text-container' name='lifestyle_level' value={2} onClick={this.handleChange} style={{backgroundColor: (this.state.lifestyle_level === 2) ? '#e5e9f3' : null}}>
                   <div className={(this.state.lifestyle_level === 2) ? 'avn-circle-radio-outer-ring-active' : 'avn-circle-radio-outer-ring'}>
                     <div className={(this.state.lifestyle_level === 2) ? 'avn-circle-radio-inner-circle-active' : 'avn-circle-radio-inner-circle'}></div>
                   </div>
                   <p><strong>Moderately Active </strong>I walk and stand for a good portion of the day.</p>
                 </button>
                 <button className='avn-button-radio-text-container' name='lifestyle_level' value={3} onClick={this.handleChange} style={{backgroundColor: (this.state.lifestyle_level === 3) ? '#e5e9f3' : null}}>
                   <div className={(this.state.lifestyle_level === 3) ? 'avn-circle-radio-outer-ring-active' : 'avn-circle-radio-outer-ring'}>
                     <div className={(this.state.lifestyle_level === 3) ? 'avn-circle-radio-inner-circle-active' : 'avn-circle-radio-inner-circle'}></div>
                   </div>
                   <p><strong>Very Active </strong>I walk and am active most of the day.</p>
                 </button>
                 <button className='avn-button-radio-text-container' name='lifestyle_level' value={4} onClick={this.handleChange} style={{backgroundColor: (this.state.lifestyle_level === 4) ? '#e5e9f3' : null}}>
                   <div className={(this.state.lifestyle_level === 4) ? 'avn-circle-radio-outer-ring-active' : 'avn-circle-radio-outer-ring'}>
                     <div className={(this.state.lifestyle_level === 4) ? 'avn-circle-radio-inner-circle-active' : 'avn-circle-radio-inner-circle'}></div>
                   </div>
                   <p><strong>Intense </strong>My job consists of picking things up or doing heavy labor.</p>
                 </button>
               </div>
             </div>
             <div className='preferences-activity-hours-category'>
               <h2>EXERCISE</h2>
               <div className='preferences-activity-hours-category-button-group'>
                 <button className='avn-button-radio-text-container' name='exercise_level' value={0} onClick={this.handleChange} style={{backgroundColor: (this.state.exercise_level === 0) ? '#e5e9f3' : null}}>
                   <div className={(this.state.exercise_level === 0) ? 'avn-circle-radio-outer-ring-active' : 'avn-circle-radio-outer-ring'}>
                     <div className={(this.state.exercise_level === 0) ? 'avn-circle-radio-inner-circle-active' : 'avn-circle-radio-inner-circle'}></div>
                   </div>
                   <p><strong>Sedentary </strong>I don't exercise.</p>
                 </button>
                 <button className='avn-button-radio-text-container' name='exercise_level' value={1} onClick={this.handleChange} style={{backgroundColor: (this.state.exercise_level === 1) ? '#e5e9f3' : null}}>
                   <div className={(this.state.exercise_level === 1) ? 'avn-circle-radio-outer-ring-active' : 'avn-circle-radio-outer-ring'}>
                     <div className={(this.state.exercise_level === 1) ? 'avn-circle-radio-inner-circle-active' : 'avn-circle-radio-inner-circle'}></div>
                   </div>
                   <p><strong>Lightly Active </strong>I do some light aerobics or lifting a few days a week.</p>
                 </button>
                 <button className='avn-button-radio-text-container' name='exercise_level' value={2} onClick={this.handleChange} style={{backgroundColor: (this.state.exercise_level === 2) ? '#e5e9f3' : null}}>
                   <div className={(this.state.exercise_level === 2) ? 'avn-circle-radio-outer-ring-active' : 'avn-circle-radio-outer-ring'}>
                     <div className={(this.state.exercise_level === 2) ? 'avn-circle-radio-inner-circle-active' : 'avn-circle-radio-inner-circle'}></div>
                   </div>
                   <p><strong>Moderately Active </strong>I do aerobic or weight training most days of the week.</p>
                 </button>
                 <button className='avn-button-radio-text-container' name='exercise_level' value={3} onClick={this.handleChange} style={{backgroundColor: (this.state.exercise_level === 3) ? '#e5e9f3' : null}}>
                   <div className={(this.state.exercise_level === 3) ? 'avn-circle-radio-outer-ring-active' : 'avn-circle-radio-outer-ring'}>
                     <div className={(this.state.exercise_level === 3) ? 'avn-circle-radio-inner-circle-active' : 'avn-circle-radio-inner-circle'}></div>
                   </div>
                   <p><strong>Very Active </strong>I do aerobic or intense weight training virtually everyday.</p>
                 </button>
                 <button className='avn-button-radio-text-container' name='exercise_level' value={4} onClick={this.handleChange} style={{backgroundColor: (this.state.exercise_level === 4) ? '#f2f2f2' : null}}>
                   <div className={(this.state.exercise_level === 4) ? 'avn-circle-radio-outer-ring-active' : 'avn-circle-radio-outer-ring'}>
                     <div className={(this.state.exercise_level === 4) ? 'avn-circle-radio-inner-circle-active' : 'avn-circle-radio-inner-circle'}></div>
                   </div>
                   <p><strong>Extreme Athlete </strong>Training is a lifestyle, it takes up much of my day and is very intense.</p>
                 </button>
               </div>
             </div>
          </div>
          <ButtonRow>
            <SaveButton
              disabled={this.state.disableSubmit}
              isLoading={this.state.isSubmitting}
              onClick={this.handleSubmit}
            />
          </ButtonRow>
        </>
      </Accordion>

        <VacationModeModal
          setting='activity level'
          open={this.state.showVacationModal}
          onClose={() => this.setState({showVacationModal: false})}
          isPaused={this.props.vacationMode > 0 && !this.props.vacationModeInfo?.practice_mode}
        />

        <UserCheckinWarning
          open={this.state.showUserCheckinWarning}
          onClose={() => this.setState({showUserCheckinWarning: false})}
          daysAfterLastCheckIn={daysAfterLastCheckIn}
        />

        <CheckinFormPortal
          open={this.state.showCheckinFormPortal}
          onClose={() => this.setState({showCheckinFormPortal: false})}    
          openFeedback={this.props.openSnackbar}
          userId={this.props.userId}
          portalId={this.props.portalId}
          loadPortalAccount={this.props.loadPortalAccount}
          weightString={this.props.weightString}
          previousWeight={this.props.previousWeight}
          previousBodyfat={this.props.previousBodyfat}
          useMetricUnits={this.props.useMetricUnits}
          daysAfterLastCheckIn={daysAfterLastCheckIn}
          gender={this.props.gender}
        />

        {/* <Dialog open={this.state.show5DayWeighInExplanation} onClose={() => { this.setState({ show5DayWeighInExplanation: false }); this.props.showModal('showWeighInModal', true)}}>
          <DialogContent className='avn-modal-content-container'>
            <p>{getFirstName(this.props.fullname)}, since you last weighed in {getDaysSinceWeighIn(this.props.lastWeighInDate)} days ago, you'll need to check in before changing your activity level.</p>
          </DialogContent>
          <DialogActions className='avn-modal-actions-container'>
            <button className='avn-action-button' onClick={() => { this.setState({ show5DayWeighInExplanation: false }); this.props.showModal('showWeighInModal', true)}}>OK</button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.showWeighInExplanation} onClose={() => { this.setState({ showWeighInExplanation: false }); this.props.showModal('showActivityWeighInModal', true)}}>
          <DialogContent className='avn-modal-content-container'>
            <p>{getFirstName(this.props.fullname)}, since you last weighed in {getDaysSinceWeighIn(this.props.lastWeighInDate)} days ago, you'll need to check in before changing your activity level.</p>
          </DialogContent>
          <DialogActions className='avn-modal-actions-container'>
            <button className='avn-action-button' onClick={() => { this.setState({ showWeighInExplanation: false }); this.props.showModal('showActivityWeighInModal', true)}}>OK</button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.showEstimatedWeightExplanation} onClose={() => { this.setState({ showEstimatedWeightExplanation: false }); this.props.showModal('showActivityWeighInModal', true)}}>
          <DialogContent className='avn-modal-content-container'>
            <p>When you weighed in today you believed that your menstrual cycle may have been artificially increasing your weight. To give the system a new starting weight for your activity level, you will need to enter an estimated weight, which is your last known weight prior to being affected by your menstrual cycle.</p>
          </DialogContent>
          <DialogActions className='avn-modal-actions-container'>
            <button className='avn-action-button' onClick={() => { this.setState({ showEstimatedWeightExplanation: false }); this.props.showModal('showActivityWeighInModal', true)}}>OK</button>
          </DialogActions>
        </Dialog> */}

        {/* <AddWeighInModal goalChangeRequested={0} activityLevelChangeRequested={1} />
        <AddActivityWeighInModal exerciseLevel={this.state.exercise_level} lifestyleLevel={this.state.lifestyle_level} /> */}
        </>
    )
  }
}

export default UpdateActivityLevel;

